<template>
  <div class="login-page">
    <!-- 右上角装饰 -->
    <div class="deco-blob"></div>

    <!-- 品牌区 -->
    <div class="brand">
      <p class="brand-hello">Hello,</p>
      <h1 class="brand-title">欢迎来到U行U客</h1>
    </div>

    <!-- 表单区 -->
    <div class="form-area">
      <!-- 手机号 -->
      <div class="input-row" :class="{ active: focusField === 'mobile' }">
        <span class="phone-prefix">+86</span>
        <span class="prefix-divider"></span>
        <input v-model="form.mobile" type="tel" maxlength="11" placeholder="请输入手机号" class="input-field"
          @focus="focusField = 'mobile'" @blur="focusField = ''" />
      </div>

      <!-- 验证码 -->
      <div class="input-row" :class="{ active: focusField === 'code' }">
        <input v-model="form.code" type="number" maxlength="6" placeholder="请输入验证码" class="input-field"
          @focus="focusField = 'code'" @blur="focusField = ''" @keyup.enter="handleLogin" />
        <span class="code-btn" :class="{ disabled: counting || !mobileValid }" @click="handleSendCode">
          {{ counting ? `${countDown}s` : '获取验证码' }}
        </span>
      </div>

      <!-- 登录按钮 -->
      <button class="login-btn" :class="{ loading: loading }" :disabled="!canLogin" @click="handleLogin">
        <span v-if="loading" class="spinner"></span>
        <span v-else>登录</span>
      </button>

      <!-- 协议 -->
      <!-- <div class="agreement">
        <span class="checkbox" :class="{ checked: agreed }" @click="agreed = !agreed">
          <i v-if="agreed" class="el-icon-check"></i>
        </span>
        <span class="agreement-text">
          登录即代表同意
          <em @click.stop="$message.info('用户协议')">《用户协议》</em>
          和
          <em @click.stop="$message.info('隐私政策')">《隐私政策》</em>
        </span>
      </div> -->
    </div>
  </div>
</template>

<script>
import { getVerifyCode, login } from '@/api/auth'
import { setMid, setRandPassword, setUserInfo, isLoggedIn } from '@/utils/auth'

export default {
  name: 'Login',
  data() {
    return {
      form: {
        mobile: '',
        code: ''
      },
      focusField: '',
      loading: false,
      counting: false,
      countDown: 60,
      agreed: false,
      timer: null
    }
  },
  computed: {
    mobileValid() {
      return /^1[3-9]\d{9}$/.test(this.form.mobile)
    },
    canLogin() {
      return this.mobileValid && this.form.code.length >= 4
      // && this.agreed
    }
  },
  created() {
    if (isLoggedIn()) {
      this.$nextTick(() => {
        this.$router.replace('/home').catch(() => {})
      })
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    async handleSendCode() {
      if (this.counting || !this.mobileValid) return
      try {
        const res = await getVerifyCode(this.form.mobile)
        this.$message.success(res.msg || '验证码已发送')
        this.counting = true
        this.countDown = 60
        this.timer = setInterval(() => {
          this.countDown--
          if (this.countDown <= 0) {
            clearInterval(this.timer)
            this.timer = null
            this.counting = false
          }
        }, 1000)
      } catch (err) {
        this.$message.error(err.message || '验证码发送失败')
      }
    },
    async handleLogin() {
      if (!this.canLogin) {
        if (!this.mobileValid) {
          this.$message.warning('请输入正确的手机号')
        } else if (!this.form.code) {
          this.$message.warning('请输入验证码')
        }
        // else if (!this.agreed) {
        //   this.$message.warning('请先同意用户协议和隐私政策')
        // }
        return
      }
      this.loading = true
      try {
        const res = await login(this.form.mobile, this.form.code)
        if (res.code == 0) {
          const data = res.data || res
          if (data.member_id) {
            setMid(data.member_id)
          }
          if (data.rand_password) {
            setRandPassword(data.rand_password)
          }
          setUserInfo({ ...data })
        }
        this.$message.success(res.msg || '登录成功')
        this.$router.replace('/home')
      } catch (err) {
        this.$message.error(err.message || '登录失败，请重试')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  background: #fff;
  padding: 80px 28px 40px;
  overflow: hidden;
}

/* 右上角装饰 */
.deco-blob {
  position: absolute;
  top: -60px;
  right: -60px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: #f5f5f5;
  z-index: 0;
}

/* 品牌区 */
.brand {
  position: relative;
  z-index: 1;
  margin-bottom: 48px;
}

.brand-hello {
  font-size: 14px;
  color: #999;
  margin-bottom: 8px;
}

.brand-title {
  font-size: 24px;
  font-weight: 700;
  color: #333;
}

/* 表单区 */
.form-area {
  position: relative;
  z-index: 1;
}

.input-row {
  display: flex;
  align-items: center;
  height: 52px;
  border-bottom: 1px solid #e8e8e8;
  transition: border-color 0.25s;
}

.input-row.active {
  border-bottom-color: #1a9bc7;
}

.phone-prefix {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  flex-shrink: 0;
}

.prefix-divider {
  width: 1px;
  height: 18px;
  background: #e8e8e8;
  margin: 0 12px;
  flex-shrink: 0;
}

.input-field {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
  color: #333;
  height: 100%;
}

.input-field::placeholder {
  color: #c0c0c0;
}

.code-btn {
  font-size: 14px;
  color: #1a9bc7;
  white-space: nowrap;
  flex-shrink: 0;
  padding-left: 12px;
  cursor: pointer;
  user-select: none;
}

.code-btn.disabled {
  color: #c0c0c0;
  cursor: not-allowed;
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 10px;
  background: #1a9bc7;
  color: #fff;
  font-size: 17px;
  font-weight: 500;
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.2s;
}

.login-btn:active {
  opacity: 0.85;
}

.login-btn:disabled {
  background: #c8c8c8;
  cursor: not-allowed;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* 协议 */
.agreement {
  display: flex;
  align-items: flex-start;
  margin-top: 20px;
  font-size: 12px;
  color: #999;
  line-height: 1.5;
}

.checkbox {
  width: 16px;
  height: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 8px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 1px;
  transition: all 0.2s;
}

.checkbox.checked {
  background: #1a9bc7;
  border-color: #1a9bc7;
}

.checkbox.checked i {
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.agreement-text em {
  color: #1a9bc7;
  font-style: normal;
  cursor: pointer;
}
</style>
